import { ComboboxTranslations } from './combobox-translations.interface';

/**
 * Default English translations for the Combobox directive
 * This serves as the fallback translation set and defines all available translation keys
 */
export const DEFAULT_COMBOBOX_TRANSLATIONS: ComboboxTranslations = {
  ariaLabel: 'Suggestions',
  noResultsText: 'No results found'
};
